<template>
  <div>
    <el-dialog
      title="查看细分类必选"
      v-model="visible"
      :close-on-click-modal="false"
      width="760px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
       <!--工具条-->
      <el-form :model="filters" class="toolbar" ref="filters" label-width="75px">
        <el-row style="padding-bottom: 0px;">
          <el-col :span="6">
            <el-form-item label="商品大类" prop="dept">
              <el-select v-model="filters.dept" filterable placeholder="请选择" disabled>
                <el-option
                  v-for="(item,i) in goodsList"
                  :key="i"
                  :label="item.CODE + ' ' + item.NAME"
                  :value="item.CODE"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="棚格图分类" prop="ifvPogcode">
              <el-select
                v-model="filters.ifvPogcode"
                filterable
                placeholder="请选择"
                @change="search"
              >
                <el-option
                v-for="(item,i) in List"
                :key="i"
                :label="item"
                :value="item"
              ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item class="leftNolabel">
              <el-button type="primary" @click="downloadTodos()">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 列表 -->
      <div v-if="tableShowOne">
        <el-table
        :data="planLists"
        class="listTowline"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%;"
      >
        <el-table-column prop="ifvDept,ifvDeptname" label="商品大类" min-width="150">
          <template slot-scope="scope"> {{scope.row.ifvDept}}&nbsp;{{scope.row.ifvDeptname}}</template>
        </el-table-column>
        <el-table-column prop="ifvPogcode,ifvPogname" label="棚格图分类" min-width="150">
          <template slot-scope="scope"> {{scope.row.ifvPogcode}}&nbsp;{{scope.row.ifvPogname}}</template>
        </el-table-column>
        <el-table-column prop="ifvSsubcls,ifvSsubclsname" label="细分类" min-width="150">
          <template slot-scope="scope"> {{scope.row.ifvSsubcls}}&nbsp;{{scope.row.ifvSsubclsname}}</template>
        </el-table-column>
        <el-table-column prop="ifvSelections" label="必选数量" min-width="150"></el-table-column>
      </el-table>
        <!-- 分页 -->
        <pagination
          v-show="totalNum>0"
          :total="totalNum"
          :page.sync="pageSize"
          :limit.sync="pageRows"
          @pagination="getRows"
        />
      </div>
      <div slot="footer" class="dalog-footer">
        <el-button @click.native="handleClose()">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination';
export default{
 props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    },
    dept : {
      type : String,
      default : ""
    },
    spaceclassNew : {
      type : String,
      default : ""
    },
    pogList: {
      type: Array,
      default(){
        return []
      }
    },
  },
  components: {
    Pagination
  },
  // computed : {
  //   filters(){
  //     return {
  //       dept : this.dept,
  //       spaceclassNew : this.spaceclassNew
  //     }
  //   }
  // },
  data: function() {
    return {
      planLists: [],
      List: [],
      goodsList: [],
      filters: {
        dept: "",
        ifvPogcode: "",
        mrId: "",
        ifvVersion: ""
      },
      pageSize: 1,
      pageRows: 10,
      totalNum: 0,
      listLoading: false,
      tableShowTwo: false,
      tableShowOne: true
    };
  },
  created() {
    this.filters.dept = this.params.dept;
    this.List = this.pogList;
    this.filters.ifvPogcode = this.params.spaceclassNew;
    this.filters.ifvVersion = this.params.isvVersion;
    this.filters.mrId = this.params.mrId;
    console.log(this.filters);
  },
  methods: {
    handleClose(){
      this.$emit('update:visible', false);
    },
    getRows() {
      this.tableShowTwo = false;
      this.tableShowOne = true;
      var _this = this;
      let para = {
        pageSize: _this.pageSize,
        pageRows: _this.pageRows,
        ifvPogcode: _this.filters.ifvPogcode,
        ifvVersion: _this.params.isvVersion,
        sipId: _this.params.sipId,
      };
      this.listLoading = true;
      this.$api.selectgoods.getItemssubclsFactorVersionList(para).then(res => {
        this.totalNum = res.data.total;
        this.planLists = res.data.result;
        this.listLoading = false;
      });
    },
    downloadTodos() {
      var _this = this;
      let planlistParams = {
        ifvPogcode: _this.filters.ifvPogcode,
        ifvVersion: _this.params.isvVersion,
        sipId: _this.params.sipId
      };
      _this.$api.selectgoods
        .downloadItemssubclsFactorVersionList(planlistParams)
        .then(res => {
          var blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = "细分类必选.xls"; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch(err =>
          this.$message({
            type: "error",
            message: err
          })
        );
    },
    search() {
      this.pageSize = 1;
      this.getRows();

    }
  },
  mounted(){
    this.search();
  }
  
  
}
</script>


// WEBPACK FOOTER //
// src/views/selectgoods/selectionmanagement/listquery/lookHistory/ssubDetail.vue